import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Style/typo.css";
import "../assets/css/style-chatbot.css";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Footer from "../../homepage/footer/Footer";

function CloudChatbot({ embedMode = false }) {
    const [html, setHtml] = useState("");

    useEffect(() => {
        window.AOS = AOS;

        fetch("/software/fetch-chatbot.html")
            .then((res) => res.text())
            .then((data) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                const baseUrl = "https://hanbiro.com";

                const fixUrl = (url) => {
                    if (url && !url.startsWith("data:") && !url.startsWith("http") && !url.startsWith("//") && !url.startsWith("#") && !url.startsWith("javascript:")) {
                        let cleanUrl = url.startsWith("./") ? url.substring(2) : url;
                        if (cleanUrl.startsWith("asset/image/")) {
                            return `${baseUrl}/assets/images/cloud/${cleanUrl.substring(12)}`;
                        }
                        return cleanUrl.startsWith("/") ? `${baseUrl}${cleanUrl}` : `${baseUrl}/software/${cleanUrl}`;
                    }
                    return url;
                };

                // Fix image paths
                doc.querySelectorAll("img, source").forEach((el) => {
                    const src = el.getAttribute("src");
                    if (src) el.setAttribute("src", fixUrl(src));
                    const srcset = el.getAttribute("srcset");
                    if (srcset) el.setAttribute("srcset", fixUrl(srcset));
                });

                // Fix relative background images in inline styles
                doc.querySelectorAll("[style]").forEach((el) => {
                    const style = el.getAttribute("style");
                    if (style && style.includes("url(")) {
                        const newStyle = style.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                            return `url('${fixUrl(url)}')`;
                        });
                        el.setAttribute("style", newStyle);
                    }
                });

                // Extract and inject styles
                const styles = doc.querySelectorAll("style");
                styles.forEach((oldStyle) => {
                    const newStyle = document.createElement("style");
                    newStyle.className = "fetched-style";
                    let cssContent = oldStyle.innerHTML;
                    // Fix URLs inside CSS
                    cssContent = cssContent.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                        return `url('${fixUrl(url)}')`;
                    });
                    newStyle.innerHTML = cssContent;
                    document.head.appendChild(newStyle);
                });

                const bodyContent = doc.body.innerHTML;
                setHtml(bodyContent);

                const scripts = doc.querySelectorAll("script");
                scripts.forEach((oldScript) => {
                    if (oldScript.src && oldScript.src.includes("aos")) return;

                    const newScript = document.createElement("script");
                    newScript.className = "fetched-script";
                    Array.from(oldScript.attributes).forEach((attr) =>
                        newScript.setAttribute(attr.name, attr.value)
                    );

                    let content = oldScript.innerHTML;
                    content = content.replace(/AOS\.init\(.*?\);?/g, "");

                    if (content.trim() || oldScript.src) {
                        // Wrap content in block scope to prevent redeclaration errors
                        if (content.trim()) {
                            newScript.appendChild(document.createTextNode(`{ ${content} }`));
                        }
                        document.body.appendChild(newScript);
                    }
                });

                setTimeout(() => {
                    AOS.init({ once: true });
                    AOS.refresh();
                }, 100);
            });

        return () => {
            // Cleanup added styles and scripts
            document.querySelectorAll(".fetched-style, .fetched-script").forEach(el => el.remove());
        };
    }, []);

    return (
        <div>
            <style>{`
                .cb-embed-wrapper {
                    overflow-x: clip;
                    width: 100%;
                }
                /* Reset section styles bleeding from main-demo.css */
                .cb-embed-wrapper section {
                    padding: initial;
                    margin: initial;
                    width: auto;
                    max-width: none;
                }
                .cb-embed-wrapper .cb-page {
                    max-width: 100%;
                    overflow-x: hidden;
                }
                .cb-embed-wrapper .cb-banner-left {
                    min-width: 0;
                }
                .cb-embed-wrapper .cb-structure-img {
                    min-width: 0;
                    flex: 1;
                }
                .cb-embed-wrapper img {
                    max-width: 100%;
                    height: auto;
                }
                /* Reset accordion styles bleeding from style-demo.css / sidebar.css */
                .cb-embed-wrapper .accordion-item {
                    background: transparent;
                    border: var(--bs-accordion-border-width, 1px) solid var(--bs-accordion-border-color, rgba(0,0,0,.125));
                    border-radius: 0;
                    transition: none;
                }
                .cb-embed-wrapper .accordion-item:not(:last-of-type) {
                    padding-bottom: 0;
                }
                .cb-embed-wrapper .accordion-body {
                    padding: 1rem 1.25rem;
                    background-color: var(--bs-accordion-bg, #fff);
                }
                .cb-embed-wrapper .accordion-button {
                    padding: 1rem 1.25rem;
                    background-color: var(--bs-accordion-btn-bg, #fff);
                    color: var(--bs-accordion-btn-color, #212529);
                    font-weight: inherit;
                }
                .cb-embed-wrapper .accordion-button.collapsed {
                    background-color: var(--bs-accordion-btn-bg, #fff);
                    color: var(--bs-accordion-btn-color, #212529);
                }
                /* Restore padding for chatbot inner sections only (not outer page-section containers) */
                .cb-embed-wrapper .cb-block {
                    padding: 60px 0;
                }
                .cb-embed-wrapper #cb-usage, .cb-embed-wrapper #cb-qa {
                    padding: 30px 0 !important;
                }
            `}</style>
            {!embedMode && (
                <NavButton
                    lang="ko"
                    option={{
                        logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                        link: "https://hanbiro.com/",
                        color: { backgroundColor: "#7061FF" },
                        itemNavClass: "item-nav nav-pur",
                        menuListProduct: "menu-list-product-item",
                        menuListVora: "vora",
                        menuListGroupware: "groupware",
                        titleTab: "mb-3",
                    }}
                />
            )}
            <div className="cb-embed-wrapper" dangerouslySetInnerHTML={{ __html: html }} />
            {!embedMode && (
                <Footer
                    option={{
                        textColor: "text-color external-link text-pur-color",
                        textlinkColor: "text-color text-pur-color",
                    }}
                />
            )}
        </div>
    );
}

export default CloudChatbot;
